// Copyright 2019 Ernesto Giron E.
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.​

// Guarda el nombre del proyecto dentro del Modulo-Programa seleccionado. ejemplo: Bonos

// ACTION TYPES //
export const types = {
  PROYECTO_LOADED: "PROYECTO_LOADED",
  // FORMACION_PROYECTOS_LOADED: "FORMACION_PROYECTOS_LOADED",
  // BIENESTAR_PROYECTOS_LOADED: "BIENESTAR_PROYECTOS_LOADED",
  // VIVIENDA_PROYECTOS_LOADED: "VIVIENDA_PROYECTOS_LOADED"
};

// REDUCERS //
export const initialState = {
  collapsed: false,
  activeProyecto: '',
  headerTitle:''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.PROYECTO_LOADED:
      const { collapsed, activeProyecto, headerTitle } = action.payload;
      return {
        ...state,
        collapsed,
        activeProyecto,
        headerTitle
      };
    default:
      return state;
  }
};

// ACTIONS //
export const setProyecto = options => ({ type: types.PROYECTO_LOADED, payload: options });
